import { keycloakInstance } from "../libs/keycloack/config"
import { type BaseQueryFn } from "@reduxjs/toolkit/dist/query/baseQueryTypes"
import {
  type FetchArgs,
  type FetchBaseQueryError,
  type FetchBaseQueryMeta,
} from "@reduxjs/toolkit/dist/query/fetchBaseQuery"
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react"

export enum ApiUrl {
  testUrl = "http://213.226.127.174:10015",
  baseUrl = " https://backend.ats.workround.tech",
}

export const baseUrl = ApiUrl.baseUrl

export const baseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError,
  {},
  FetchBaseQueryMeta
> = fetchBaseQuery({
  baseUrl: baseUrl,
  prepareHeaders: (headers, api) => {
    headers.set("Authorization", `Bearer ${keycloakInstance.token}`)

    return headers
  },
})
